import { useCvLanguage } from '../cvLanguage';
import React, { useLayoutEffect, useRef, useState } from 'react';
import { Box, Button, Typography, ToggleButton, ToggleButtonGroup } from '@mui/material';
import DownloadRounded from '@mui/icons-material/DownloadRounded';
import CurriculumDisplay from '../../CurriculumDisplay';
export default function CvPreview({
  data,
  documentLanguage = 'es',
  onDownload,
  downloading,
  standalone = false
}) {
  const { t } = useCvLanguage();
  const [readable, setReadable] = useState(true);
  const container = useRef(null),
    paper = useRef(null),
    [size, setSize] = useState({
      scale: 1,
      height: 1123
    });
  useLayoutEffect(() => {
    const measure = () => {
      if (!container.current || !paper.current) return;
      if (!container.current.clientWidth || !paper.current.offsetWidth) return;
      const scale = Math.min(1, container.current.clientWidth / paper.current.offsetWidth);
      const height = paper.current.offsetHeight * scale;
      setSize(previous => previous.scale === scale && previous.height === height ? previous : {
        scale,
        height
      });
    };
    measure();
    if (!window.ResizeObserver) return;
    const observer = new ResizeObserver(measure);
    observer.observe(container.current);
    observer.observe(paper.current);
    return () => observer.disconnect();
  }, [data, readable, documentLanguage]);
  return <Box className={`cv-preview ${standalone ? 'cv-preview-standalone' : ''} ${readable ? 'is-readable' : ''}`}>
    <Box className="cv-preview-heading"><Box><Typography component="h2">{t("Vista previa")}</Typography><Typography variant="caption" color="text.secondary">{t("Tu experiencia, lista para compartir.")}</Typography></Box><Button variant="contained" startIcon={<DownloadRounded />} onClick={onDownload} disabled={downloading}>{downloading ? t("Generando…") : t("Descargar PDF")}</Button></Box>
    <ToggleButtonGroup className="cv-preview-mode" value={readable ? 'read' : 'page'} exclusive onChange={(_, value) => {
      if (value) setReadable(value === 'read');
    }} aria-label={t("Modo de vista previa")}><ToggleButton value="read">{t("Lectura cómoda")}</ToggleButton><ToggleButton value="page">{t("Página A4")}</ToggleButton></ToggleButtonGroup>
    <Box className="cv-preview-stage" ref={container}>
      <Box className="cv-scaled-page" sx={{
        height: size.height
      }}><Box className="cv-document-transform" sx={{
          width: '210mm',
          transform: `scale(${size.scale})`,
          transformOrigin: 'top left'
        }}><CurriculumDisplay language={documentLanguage} data={data} ref={paper} /></Box></Box>
    </Box>
  </Box>;
}
